var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    color: "#09A0D7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM6 6.4C6 6.17875 6.17875 6 6.4 6H15.6C15.8212 6 16 6.17875 16 6.4V15.6C16 15.8212 15.8212 16 15.6 16H6.4C6.17875 16 6 15.8212 6 15.6V6.4ZM11.2 11.8H15.2V10.2H11.2V11.8ZM11.9964 11.3536C11.9027 11.2598 11.85 11.1326 11.85 11C11.85 10.8674 11.9027 10.7402 11.9964 10.6464C12.0902 10.5527 12.2174 10.5 12.35 10.5C12.4826 10.5 12.6098 10.5527 12.7036 10.6464C12.7973 10.7402 12.85 10.8674 12.85 11C12.85 11.1326 12.7973 11.2598 12.7036 11.3536C12.6098 11.4473 12.4826 11.5 12.35 11.5C12.2174 11.5 12.0902 11.4473 11.9964 11.3536Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.8968bebac0c943416e00949cf9fe1f3e.svg";
export { ForwardRef as ReactComponent };